import { h } from "@stencil/core";
import { updateShowcase } from "../utils";
import { markdownReadmeModel } from "./models";
let initialMarkdown = markdownReadmeModel;
let textareaRef;
const handleValueChange = () => {
    initialMarkdown = textareaRef.value;
    // TODO: Until we support external slots in the ch-flexible-layout-render,
    // this is a hack to update the render of the widget and thus re-render the
    // combo-box updating the displayed items
    updateShowcase();
};
const render = () => (h("div", { class: "markdown-test-main-wrapper" }, h("div", { class: "markdown-test-properties" }), h("textarea", { "aria-label": "Markdown content", class: "input", value: initialMarkdown, onInput: handleValueChange, ref: el => (textareaRef = el) }), h("ch-math-viewer", { value: initialMarkdown })));
export const mathViewerShowcaseStory = {
    render: render
};
